/*
* Created on Jan 08, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

import HeaderUtilServiceComponent from "./HeaderUtilServiceComponent";
import HeaderUtilMoreComponent from "./HeaderUtilMoreComponent";
import HeaderUtilAccountComponent from "./HeaderUtilAccountComponent";
import {useAuthSession} from "../../context/AuthSessionContext";
import HeaderUtilSettingComponent from "./HeaderUtilSettingComponent";

const HeaderUtilComponent = () => {
    const {session} = useAuthSession();

    return (
        <div className="utils">
            <HeaderUtilSettingComponent />
            <HeaderUtilMoreComponent />
            {
                (session === true || session.length > 0) && (
                    <>
                        <div className="divide"/>
                        <HeaderUtilAccountComponent />
                    </>
                )
            }
        </div>
    );
};

export default HeaderUtilComponent;